"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultimediaTextModel = function (_Observer) {
    _inherits(MultimediaTextModel, _Observer);

    function MultimediaTextModel(observers, id, request) {
        _classCallCheck(this, MultimediaTextModel);

        var _this = _possibleConstructorReturn(this, (MultimediaTextModel.__proto__ || Object.getPrototypeOf(MultimediaTextModel)).call(this, observers, id, request));

        _this.MultimediaText = [];
        return _this;
    }

    _createClass(MultimediaTextModel, [{
        key: "GetMultimediaTextFromTariffProduct",
        value: function GetMultimediaTextFromTariffProduct(tariffProduct) {
            if (tariffProduct !== null && tariffProduct !== undefined) {
                var me = this;
                var req = "/multimediatext";
                this.request.setRequest(req);
                this.request.setType("POST");
                var sendData = {
                    product: tariffProduct
                };
                this.request.setData(JSON.stringify(sendData));
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.MultimediaText = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "MultimediaTextFromProduct";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }, {
        key: "GetMultimediaTextFromTicketId",
        value: function GetMultimediaTextFromTicketId(id) {
            if (id !== null && id !== undefined) {
                var me = this;
                var req = "/multimediatext?ticketId=" + id;
                this.request.setRequest(req);
                this.request.setType("GET");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.MultimediaText = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "MultimediaTextFromId";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }]);

    return MultimediaTextModel;
}(_Observer3.default);

exports.default = MultimediaTextModel;